import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.clearable)?_c(VTooltip,{attrs:{"bottom":"","open-delay":"500"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({staticClass:"clear-btn",attrs:{"fab":""},on:{"click":function($event){$event.stopPropagation();return _vm.onClearClick.apply(null, arguments)}}},on),[_c(VIcon,{staticStyle:{"color":"var(--grey-300)","font-size":"16px"}},[_vm._v("mdi-close-thick")])],1)]}}],null,false,1264564566)},[_c('div',{staticClass:"tooltip-max-width"},[_vm._v(_vm._s(_vm.clearText))])]):_vm._e(),(_vm.$vuetify.breakpoint.smAndDown)?_c('div',{staticClass:"mobile-runnit-layers"},[_c('div',{ref:"runnitLayersContainer",staticClass:"runnit-layers-container",class:{
				...(!_vm.noClick && {
					'runnit-layers-container-no-selection-mode': !_vm.isSelectionMode,
					'runnit-layers-container-selection-mode': _vm.isSelectionMode,
				}),
				'gradient-border': _vm.isSelectionMode && _vm.isSelected,
				'comparison-active': _vm.useComparisonSlider,
			},style:({
				...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
					borderRadius: _vm.overrideBorderRadius || '12px',
				}),
				...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
					borderRadius: _vm.overrideBorderRadius || '8px',
				}),
				width: _vm.computedWidth || '100%',
				height: _vm.computedHeight || '100%',
				...(_vm.maxHeight && {
					maxHeight: _vm.maxHeight,
				}),
			})},[_c(VSlideYTransition,[(_vm.isSelectionMode)?_c('div',{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],staticClass:"runnit-layers-container-selected",class:{ selected: _vm.isSelected },style:({
						...(_vm.$vuetify.breakpoint.mdAndUp && {
							width: '40px',
							height: '40px',
						}),
						...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
							borderRadius: _vm.overrideBorderRadius || '12px',
						}),
						...(_vm.dimensions.width < _vm.WIDTH_XS_BREAKPOINT && {
							borderRadius: _vm.overrideBorderRadius || '4px',
						}),
					}),on:{"click":_vm.onClick}},[(_vm.isSelected)?_c(VIcon,{staticStyle:{"font-size":"27px","color":"white"}},[_vm._v(" mdi-check ")]):(_vm.isMultiSelection)?_c(VIcon,{staticStyle:{"font-size":"27px"},style:({
							color: _vm.isSelected ? 'var(--primary-green)' : 'var(--grey-300)',
						})},[_vm._v(" mdi-plus-circle-outline ")]):(_vm.isSingleSelection)?_c(VIcon,{staticStyle:{"font-size":"27px"},style:({
							color: _vm.isSelected ? 'var(--primary-green)' : 'var(--grey-300)',
						})},[_vm._v(" mdi-check ")]):_vm._e()],1):_vm._e()]),(_vm.srcIsError || _vm.isErrorPlaceholder)?_c(VTooltip,{attrs:{"top":"","nudge-top":-50,"open-delay":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"error-placeholder",style:({
							width: _vm.computedWidth || '100%',
							height: _vm.computedHeight || '100%',
							...(_vm.maxHeight && {
								maxHeight: _vm.maxHeight,
							}),
						})},on),[_c(VIcon,{staticStyle:{"font-size":"48px","color":"var(--grey-300)"}},[_vm._v("mdi-alert-circle-outline")]),_c('div',{staticClass:"error-text"},[_vm._v("Error loading layers")])],1)]}}],null,false,2734311430)},[_c('span',[_vm._v(_vm._s(_vm.errorMessage))])]):(_vm.isLoadingPlaceholder)?_c(VTooltip,{attrs:{"top":"","nudge-top":-50,"open-delay":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"loading-placeholder",style:({
							width: _vm.computedWidth || '100%',
							height: _vm.computedHeight || '100%',
							...(_vm.maxHeight && {
								maxHeight: _vm.maxHeight,
							}),
						})},on),[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"var(--primary-blue)","size":"48"}}),_c('div',{staticClass:"loading-text"},[_vm._v("Loading layers...")])],1)]}}],null,false,526491697)},[_c('span',[_vm._v("Loading layers...")])]):(_vm.displayFileSrc && !_vm.srcIsError)?_c('img',{ref:"runnitLayersImage",class:{
					'cursor-pointer': !_vm.noClick && !_vm.isSelectionMode,
					'cursor-default': _vm.noClick || _vm.isSelectionMode,
				},style:({
					width: _vm.computedWidth || '100%',
					height: _vm.computedHeight || '100%',
					objectFit: 'cover',
					...(_vm.maxHeight && {
						maxHeight: _vm.maxHeight,
					}),
					...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '12px',
					}),
					...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '8px',
					}),
				}),attrs:{"src":_vm.displayFileSrc,"alt":_vm.displayFileAlt,"draggable":_vm.draggable},on:{"click":_vm.onClick,"load":_vm.onImageLoad,"error":_vm.onImageError}}):_vm._e(),(!_vm.isSelectionMode && !_vm.noClick)?_c('div',{staticClass:"layers-indicator",style:({
					...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '12px',
					}),
					...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '8px',
					}),
				})},[_c(VIcon,{staticStyle:{"font-size":"16px","color":"white"}},[_vm._v("mdi-layers-triple")]),_c('span',{staticClass:"layers-text"},[_vm._v("Layers")])],1):_vm._e()],1)]):_c('div',{staticClass:"desktop-runnit-layers"},[_c('div',{ref:"runnitLayersContainer",staticClass:"runnit-layers-container",class:{
				...(!_vm.noClick && {
					'runnit-layers-container-no-selection-mode': !_vm.isSelectionMode,
					'runnit-layers-container-selection-mode': _vm.isSelectionMode,
				}),
				'gradient-border': _vm.isSelectionMode && _vm.isSelected,
				'comparison-active': _vm.useComparisonSlider,
			},style:({
				...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
					borderRadius: _vm.overrideBorderRadius || '12px',
				}),
				...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
					borderRadius: _vm.overrideBorderRadius || '8px',
				}),
				width: _vm.computedWidth || '100%',
				height: _vm.computedHeight || '100%',
				...(_vm.maxHeight && {
					maxHeight: _vm.maxHeight,
				}),
			})},[_c(VSlideYTransition,[(_vm.isSelectionMode)?_c('div',{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],staticClass:"runnit-layers-container-selected",class:{ selected: _vm.isSelected },style:({
						...(_vm.$vuetify.breakpoint.mdAndUp && {
							width: '40px',
							height: '40px',
						}),
						...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
							borderRadius: _vm.overrideBorderRadius || '12px',
						}),
						...(_vm.dimensions.width < _vm.WIDTH_XS_BREAKPOINT && {
							borderRadius: _vm.overrideBorderRadius || '4px',
						}),
					}),on:{"click":_vm.onClick}},[(_vm.isSelected)?_c(VIcon,{staticStyle:{"font-size":"27px","color":"white"}},[_vm._v(" mdi-check ")]):(_vm.isMultiSelection)?_c(VIcon,{staticStyle:{"font-size":"27px"},style:({
							color: _vm.isSelected ? 'var(--primary-green)' : 'var(--grey-300)',
						})},[_vm._v(" mdi-plus-circle-outline ")]):(_vm.isSingleSelection)?_c(VIcon,{staticStyle:{"font-size":"27px"},style:({
							color: _vm.isSelected ? 'var(--primary-green)' : 'var(--grey-300)',
						})},[_vm._v(" mdi-check ")]):_vm._e()],1):_vm._e()]),(_vm.srcIsError || _vm.isErrorPlaceholder)?_c(VTooltip,{attrs:{"top":"","nudge-top":-50,"open-delay":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"error-placeholder",style:({
							width: _vm.computedWidth || '100%',
							height: _vm.computedHeight || '100%',
							...(_vm.maxHeight && {
								maxHeight: _vm.maxHeight,
							}),
						})},on),[_c(VIcon,{staticStyle:{"font-size":"48px","color":"var(--grey-300)"}},[_vm._v("mdi-alert-circle-outline")]),_c('div',{staticClass:"error-text"},[_vm._v("Error loading layers")])],1)]}}],null,false,2734311430)},[_c('span',[_vm._v(_vm._s(_vm.errorMessage))])]):(_vm.isLoadingPlaceholder)?_c(VTooltip,{attrs:{"top":"","nudge-top":-50,"open-delay":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"loading-placeholder",style:({
							width: _vm.computedWidth || '100%',
							height: _vm.computedHeight || '100%',
							...(_vm.maxHeight && {
								maxHeight: _vm.maxHeight,
							}),
						})},on),[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"var(--primary-blue)","size":"48"}}),_c('div',{staticClass:"loading-text"},[_vm._v("Loading layers...")])],1)]}}])},[_c('span',[_vm._v("Loading layers...")])]):(_vm.displayFileSrc && !_vm.srcIsError)?_c('img',{ref:"runnitLayersImage",class:{
					'cursor-pointer': !_vm.noClick && !_vm.isSelectionMode,
					'cursor-default': _vm.noClick || _vm.isSelectionMode,
				},style:({
					width: _vm.computedWidth || '100%',
					height: _vm.computedHeight || '100%',
					objectFit: 'cover',
					...(_vm.maxHeight && {
						maxHeight: _vm.maxHeight,
					}),
					...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '12px',
					}),
					...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '8px',
					}),
				}),attrs:{"src":_vm.displayFileSrc,"alt":_vm.displayFileAlt,"draggable":_vm.draggable},on:{"click":_vm.onClick,"load":_vm.onImageLoad,"error":_vm.onImageError}}):_vm._e(),(!_vm.isSelectionMode && !_vm.noClick)?_c('div',{staticClass:"layers-indicator",style:({
					...(_vm.dimensions.width > _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '12px',
					}),
					...(_vm.dimensions.width <= _vm.WIDTH_XS_BREAKPOINT && {
						borderRadius: _vm.overrideBorderRadius || '8px',
					}),
				})},[_c(VIcon,{staticStyle:{"font-size":"16px","color":"white"}},[_vm._v("mdi-layers-triple")]),_c('span',{staticClass:"layers-text"},[_vm._v("Layers")])],1):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }